
import state from './modulePaymentsState.js'
import mutations from './modulePaymentsMutations.js'
import actions from './modulePaymentsActions.js'
import getters from './modulePaymentsGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}